import { render, staticRenderFns } from "./CallManage.vue?vue&type=template&id=7bd5e471&"
import script from "./CallManage.vue?vue&type=script&lang=js&"
export * from "./CallManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports